module.exports = __webpack_public_path__ + "static/media/FiftyOffText.28e1f504.svg";